// extracted by mini-css-extract-plugin
export default {"work":"Home_work__ouiic","inner":"Home_inner__FuaWw","grid":"Home_grid__fIrSL","cell":"Home_cell__nqwQQ"};